import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DiagramJsonHandlerService} from './diagram-json-handler.service';
import {DiagramMetaService} from './diagram-meta.service';
import {DiagramUpdateService} from './diagram-update.service';

@NgModule({
  imports: [CommonModule],
  providers: [DiagramJsonHandlerService, DiagramUpdateService, DiagramMetaService],
  declarations: []
})
export class DiagramDataModule {}
